import { __module as interopRequireDefault } from "../../../../_virtual/interopRequireDefault.es.js";
(function(module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
export {
  interopRequireDefaultExports as i
};
//# sourceMappingURL=interopRequireDefault.es.js.map
